class StorageWrapper {
  private isSupported: boolean;
  private memoryStorage: Map<string, string>;

  constructor() {
    this.memoryStorage = new Map();
    this.isSupported = this.checkSupport();
  }

  private checkSupport(): boolean {
    try {
      const testKey = '__test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  getItem(key: string): string | null {
    if (this.isSupported) {
      return localStorage.getItem(key);
    }
    return this.memoryStorage.get(key) || null;
  }

  setItem(key: string, value: string): void {
    if (this.isSupported) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        console.warn('LocalStorage full or error', e);
      }
    } else {
      this.memoryStorage.set(key, value);
    }
  }

  removeItem(key: string): void {
    if (this.isSupported) {
      localStorage.removeItem(key);
    } else {
      this.memoryStorage.delete(key);
    }
  }

  clear(): void {
    if (this.isSupported) {
      localStorage.clear();
    } else {
      this.memoryStorage.clear();
    }
  }

  get isAvailable(): boolean {
    return this.isSupported;
  }
}

export const appStorage = new StorageWrapper();
